
        
    const runtime = require("../../../node_modules/simple-nunjucks-loader/lib/cjs/runtime.js");
    
    const __nunjucks_module_dependencies__ = {};
    
    __nunjucks_module_dependencies__.templates = {};
    __nunjucks_module_dependencies__.globals = {};
    __nunjucks_module_dependencies__.extensions = {};
    __nunjucks_module_dependencies__.filters = {};
    __nunjucks_module_dependencies__.assets = {};
    
    
    
    
    
    
        
            __nunjucks_module_dependencies__.templates["milestone/backlog.njk"] = (function() {
                function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div id=\"milestone_";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id"), env.opts.autoescape);
output += "\" class=\"milestone-box ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id")) {
output += "draggable";
;
}
output += " ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"visible_in_roadmap")) {
output += "available";
;
}
else {
output += "unavailable";
;
}
output += " ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"reached")) {
output += "closed";
;
}
else {
output += "open";
;
}
output += "\" data-milestone data-milestone-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id"), env.opts.autoescape);
output += "\">\n    <div class=\"header ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id")) {
output += "backlog";
;
}
output += "\" id=\"milestone_";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id"), env.opts.autoescape);
output += "_header\">\n        <div class=\"main-details\">\n            <div class=\"name-container\">\n                <span class=\"name\">\n                    <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"name"), env.opts.autoescape);
output += "</span>\n                </span>\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id")) {
output += "\n                    <div class=\"percentage\">\n                        <div class=\"filler\" id=\"milestone_";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id"), env.opts.autoescape);
output += "_percentage_filler\" style=\"transform: scaleX(";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"percent_complete") < 100) {
output += "0.";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"percent_complete"), env.opts.autoescape);
;
}
else {
output += "1";
;
}
output += ");\"></div>\n                    </div>\n                ";
;
}
output += "\n            </div>\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id")) {
output += "\n                <div class=\"dates\">\n                    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 15, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["calendar-alt",{},"far"]))), env.opts.autoescape);
output += "\n                    ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"starting_date") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"scheduled_date"))) {
output += "\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"starting_date")) {
output += "\n                            <span class=\"start-date\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"starting_date"), env.opts.autoescape);
output += "</span>\n                        ";
;
}
output += "\n                        ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"starting_date") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"scheduled_date"))) {
output += "\n                            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 21, colno = 46, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["arrow-alt-circle-right",{},"far"]))), env.opts.autoescape);
output += "\n                        ";
;
}
output += "\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"scheduled_date")) {
output += "\n                            <span class=\"end-date\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"scheduled_date"), env.opts.autoescape);
output += "</span>\n                        ";
;
}
output += "\n                    ";
;
}
else {
output += "\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "T")),"agile")),"backlog")),"milestone_unscheduled"), env.opts.autoescape);
output += "\n                    ";
;
}
output += "\n                </div>\n            ";
;
}
output += "\n        </div>\n        <div class=\"milestone-counts-container\">\n            <div class=\"count\">\n                <span id=\"milestone_";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id"), env.opts.autoescape);
output += "_issues_count\">\n                    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"issues_count_open"), env.opts.autoescape);
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"issues_count_closed") > 0) {
output += "&nbsp;(";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"issues_count_closed"), env.opts.autoescape);
output += ")";
;
}
output += "\n                </span>\n                <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "T")),"agile")),"backlog")),"milestone_header_issues"), env.opts.autoescape);
output += "</span>\n            </div>\n            <div class=\"count\">\n                <span id=\"milestone_";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id"), env.opts.autoescape);
output += "_points_count\" class=\"issue_estimates\">";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"points")),"spent") + runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"points")),"estimated") > 0) {
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"points")),"spent"), env.opts.autoescape);
output += " / ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"points")),"estimated"), env.opts.autoescape);
;
}
else {
output += "0";
;
}
output += "</span>\n                <span class=\"issue_estimates\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "T")),"agile")),"backlog")),"milestone_header_points"), env.opts.autoescape);
output += "</span>\n            </div>\n            <div class=\"count\">\n                <span id=\"milestone_";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id"), env.opts.autoescape);
output += "_hours_count\" class=\"issue_estimates\">";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"hours")),"estimated") + runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"hours")),"spent") > 0) {
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"hours_estimated_formatted"), env.opts.autoescape);
output += " / ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"hours_spent_formatted"), env.opts.autoescape);
;
}
else {
output += "0";
;
}
output += "</span>\n                <span class=\"issue_estimates\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "T")),"agile")),"backlog")),"milestone_header_hours"), env.opts.autoescape);
output += "</span>\n            </div>\n        </div>\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id")) {
output += "\n            <div class=\"actions-container\">\n                <input type=\"checkbox\" class=\"fancy-checkbox trigger-show-issues\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id"), env.opts.autoescape);
output += "\" name=\"show_issues\" id=\"milestone-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id"), env.opts.autoescape);
output += "-show-issues-checkbox\" ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"is_closed") && (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"issues_count_closed") + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"issues_count_open") > 0)) {
output += "checked";
;
}
output += ">\n                <label class=\"button secondary toggle-issues\" for=\"milestone-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id"), env.opts.autoescape);
output += "-show-issues-checkbox\">\n                    <span class=\"icon\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 52, colno = 57, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["toggle-on",{"classes": "checked"}]))), env.opts.autoescape);
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 52, colno = 120, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["toggle-off",{"classes": "unchecked"}]))), env.opts.autoescape);
output += "</span>\n                    <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "T")),"agile")),"backlog")),"milestone_header_show_issues"), env.opts.autoescape);
output += "</span>\n                </label>\n                <div class=\"dropper-container\">\n                    <button class=\"dropper secondary icon\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 56, colno = 77, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["ellipsis-v"]))), env.opts.autoescape);
output += "</button>\n                    <div class=\"dropdown-container\" id=\"milestone_";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id"), env.opts.autoescape);
output += "_moreactions\">\n                        <div class=\"list-mode\">\n                            <a href=\"#echo make_url project_milestone_details\" class=\"list-item\">\n                                <span class=\"icon\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 60, colno = 69, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["columns"]))), env.opts.autoescape);
output += "</span>\n                                <span class=\"name\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "T")),"agile")),"backlog")),"milestone_show_overview"), env.opts.autoescape);
output += "</span>\n                            </a>\n                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"can_edit")) {
output += "\n                                <a href=\"javascript:void(0);\" class=\"list-item trigger-backdrop\" data-url=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"mark_finished_url"), env.opts.autoescape);
output += "\">\n                                    <span class=\"icon\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 65, colno = 73, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["flag-checkered"]))), env.opts.autoescape);
output += "</span>\n                                    <span class=\"name\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "T")),"agile")),"backlog")),"milestone_mark_as_finished"), env.opts.autoescape);
output += "</span>\n                                </a>\n                                <div class=\"list-item separator\"></div>\n                                <a href=\"javascript:void(0);\" class=\"list-item trigger-backdrop\" data-url=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"backdrop_url"), env.opts.autoescape);
output += "\">\n                                    <span class=\"icon\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 70, colno = 73, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["edit"]))), env.opts.autoescape);
output += "</span>\n                                    <span class=\"name\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "T")),"agile")),"backlog")),"milestone_edit"), env.opts.autoescape);
output += "</span>\n                                </a>\n                                <div class=\"list-item separator\"></div>\n                                <a href=\"javascript:void(0);\" class=\"list-item trigger-delete-milestone\" data-milestone-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id"), env.opts.autoescape);
output += "\" data-url=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"url"), env.opts.autoescape);
output += "\">\n                                    <span class=\"icon\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 75, colno = 73, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["times"]))), env.opts.autoescape);
output += "</span>\n                                    <span class=\"name\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "T")),"agile")),"backlog")),"milestone_delete"), env.opts.autoescape);
output += "</span>\n                                </a>\n                            ";
;
}
output += "\n                        </div>\n                    </div>\n                </div>\n            </div>\n        ";
;
}
output += "\n    </div>\n    <div class=\"milestone-issues-container ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"issues_count") == 0) {
output += "empty";
;
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"is_closed") || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"issues_count_closed") + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"issues_count_open") == 0)) {
output += "collapsed";
;
}
output += "\">\n        <div id=\"milestone_";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id"), env.opts.autoescape);
output += "_issues\" class=\"milestone-issues hide-closed issues jsortable intersortable\"></div>\n        <div class=\"milestone_error_issues\" style=\"display: none;\" id=\"milestone_";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id"), env.opts.autoescape);
output += "_message\"></div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

            })();
        

        function nunjucksTemplate(ctx = {}) {
            const templateContext = {
                __nunjucks_loader_assets__: __nunjucks_module_dependencies__.assets,
                ...ctx
            };

            var nunjucks = (runtime && runtime.default || runtime)(
                {"dev":true,"jinjaCompat":false,"isAsyncTemplate":false},
                __nunjucks_module_dependencies__
            );

            if (nunjucks.isAsync()) {
                return nunjucks.renderAsync(
                    "milestone/backlog.njk",
                    templateContext
                );
            }
        
            return nunjucks.render(
                "milestone/backlog.njk",
                templateContext
            );
        };

        nunjucksTemplate.__nunjucks_precompiled_template__ = __nunjucks_module_dependencies__.templates["milestone/backlog.njk"];
        nunjucksTemplate.__nunjucks_module_dependencies__ = __nunjucks_module_dependencies__;

        exports = module.exports = nunjucksTemplate;
    